import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { VerticalNavigation, VerticalNavLink } from './VerticalNavigation';
import { NotificationBell } from '../modules/Notifications';
import { useAuth } from '../modules/Authentication';
import { usePageTitle } from './usePageTitle';
import './OperatorLayout.css';

const NAV_ITEMS = [
    { name: 'dashboard', iconName: 'chart-pie', label: 'داشبورد', end: true },
    { name: 'users', iconName: 'person-group', label: 'مدیریت کاربران' },
    { name: 'ekyc-queue', iconName: 'inbox-stack', label: 'صف بررسی احراز هویت' },
    { name: 'evidence-review', iconName: 'document', label: 'صف بررسی مدارک' },
    { name: 'payments', iconName: 'card', label: 'مدیریت پرداخت‌ها' },
    { name: 'activity-logs', iconName: 'clock-filled', label: 'فعالیت‌های من' },
    { name: 'tickets', iconName: 'ticket', label: 'تیکت‌ها' },
];

function OperatorLayout() {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const pageTitle = usePageTitle(NAV_ITEMS, (item) => `/operator/${item.name}`);

    const handleLogout = async () => {
        await logout();
        navigate('/operator/login');
    };

    const items = NAV_ITEMS.map(({ name, iconName, label, end }) => ({
        name,
        component: () => (
            <VerticalNavLink href={`/operator/${name}`} iconName={iconName} end={end}>
                {label}
            </VerticalNavLink>
        ),
    }));

    return (
        <div className="operator-layout">
            <VerticalNavigation
                items={items}
                profileHref="/operator/profile"
                releaseHref="/operator/releases"
                setupGuideHref="/guide/operator"
                helpHref="/help/operator"
                onLogout={handleLogout}
            />
            <main className="operator-layout-main">
                <header className="operator-topbar">
                    <span className="operator-topbar-title">{pageTitle}</span>
                    <div className="operator-topbar-actions">
                        <NotificationBell scope="operator" />
                    </div>
                </header>
                <Outlet />
            </main>
        </div>
    );
}

export default OperatorLayout;